import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import AppsGrid from '@/components/features/Apps/AppsGrid';

/**
 * Apps & integrations marketplace (dummy UI). Reachable from the More
 * page; lists the third-party systems Hero will connect with (banks,
 * accounting, ERP, GPS). No backend connector yet — this is the design
 * surface ahead of the integrations engine.
 */
export default function AppsPage() {
  const { t } = useTranslation(['a-carrier-dashboard']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('a-carrier-dashboard:apps_page.title'));
  }, [setPageName, t]);

  return <AppsGrid />;
}
